export const ListData = {
    CurrencyList: [
        // { id: 1, name: "AUD ($)" },
        // { id: 2, name: "BDT (৳)" },
        // { id: 3, name: "CAD ($)" },
        // { id: 4, name: "EUR (€)" },
        // { id: 5, name: "GBP (£)" },
        // { id: 6, name: "JPY (¥)" },
        // { id: 7, name: "USD ($)" },
      
        // { id: 1, name: "USD ($)" },
        // { id: 2, name: "BDT (৳)" },
        // { id: 3, name: "EUR (€)" },
        // { id: 4, name: "GBP (£)" },
        // // { id: 5, name: "INR (₹)" },
        // { id: 6, name: "CAD ($)" },
        // // { id: 6, name: "CNY (¥)" },
        // { id: 7, name: "JPY (¥)" },
        // { id: 8, name: "AUD (A$)" },
      
        // { id: 9, name: "SGD (S$)" }
        
        { id: 2, name: "BDT (৳)" },
        { id: 1, name: "USD ($)" },
        { id: 8, name: "AUD (A$)" },
        { id: 6, name: "CAD ($)" },
        { id: 3, name: "EUR (€)" },
        { id: 4, name: "GBP (£)" },
        { id: 7, name: "JPY (¥)" }
    
        
    ],
    CountryList: [
        { id: 1, name: "Afghanistan" },
        { id: 2, name: "Albania" },
        { id: 3, name: "Algeria" },
        { id: 4, name: "Andorra" },
        { id: 5, name: "Angola" },
        { id: 6, name: "Antigua & Barbuda" },
        { id: 7, name: "Argentina" },
        { id: 8, name: "Armenia" },
        { id: 9, name: "Australia" },
        { id: 10, name: "Austria" },
        { id: 11, name: "Azerbaijan" },
        { id: 12, name: "The Bahamas" },
        { id: 13, name: "Bahrain" },
        { id: 14, name: "Bangladesh" },
        { id: 15, name: "Barbados" },
        { id: 16, name: "Belarus" },
        { id: 17, name: "Belgium" },
        { id: 18, name: "Belize" },
        { id: 19, name: "Benin" },
        { id: 110, name: "Bhutan" },
        { id: 21, name: "Bolivia" },
        { id: 22, name: "Bosnia & Herzegovina" },
        { id: 23, name: "Botswana" },
        { id: 24, name: "Brazil" },
        { id: 25, name: "Brunei" },
        { id: 26, name: "Bulgaria" },
        { id: 27, name: "Burkina Faso" },
        { id: 28, name: "Burundi" },
        { id: 29, name: "Cabo Verde" },
        { id: 210, name: "Cambodia" },
        { id: 31, name: "Cameroon" },
        { id: 32, name: "Canada" },
        { id: 33, name: "Chad" },
        { id: 34, name: "Chile" },
        { id: 35, name: "China" },
        { id: 36, name: "Colombia" },
        { id: 37, name: "Comoros" },
        { id: 38, name: "Congo" },
        { id: 39, name: "Costa Rica" },
        { id: 310, name: "Côte d'Ivoire" },
        { id: 41, name: "Croatia" },
        { id: 42, name: "Cuba" },
        { id: 43, name: "Cyprus" },
        { id: 44, name: "Czech Republic" },
        { id: 45, name: "Denmark" },
        { id: 46, name: "Djibouti" },
        { id: 47, name: "Dominica" },
        { id: 48, name: "Dominican Republic" },
        { id: 49, name: "Ecuador" },
        { id: 410, name: "Egypt" },
        { id: 51, name: "El Salvador" },
        { id: 52, name: "Equatorial Guinea" },
        { id: 53, name: "Eritrea" },
        { id: 54, name: "Estonia" },
        { id: 55, name: "Eswatini" },
        { id: 56, name: "Ethiopia" },
        { id: 57, name: "Fiji" },
        { id: 58, name: "Finland" },
        { id: 59, name: "France" },
        { id: 510, name: "Gabon" },
        { id: 61, name: "The Gambia" },
        { id: 62, name: "Georgia" },
        { id: 63, name: "Germany" },
        { id: 64, name: "Ghana" },
        { id: 65, name: "Greece" },
        { id: 66, name: "Grenada" },
        { id: 67, name: "Guatemala" },
        { id: 68, name: "Guinea" },
        { id: 69, name: "Guinea-Bissau" },
        { id: 610, name: "Guyana" },
        { id: 71, name: "Haiti" },
        { id: 72, name: "Honduras" },
        { id: 73, name: "Hungary" },
        { id: 74, name: "Iceland" },
        { id: 75, name: "India" },
        { id: 76, name: "Indonesia" },
        { id: 77, name: "Iran" },
        { id: 78, name: "Iraq" },
        { id: 79, name: "Ireland" },
        { id: 710, name: "Israel" },
        { id: 81, name: "Italy" },
        { id: 82, name: "Jamaica" },
        { id: 83, name: "Japan" },
        { id: 84, name: "Jordan" },
        { id: 85, name: "Kazakhstan" },
        { id: 86, name: "Kenya" },
        { id: 87, name: "Kiribati" },
        { id: 88, name: "North Korea, " },
        { id: 89, name: "South Korea" },
        { id: 810, name: "Kosovo" },
        { id: 91, name: "Kuwait" },
        { id: 92, name: "Kyrgyzstan" },
        { id: 93, name: "Laos" },
        { id: 94, name: "Latvia" },
        { id: 95, name: "Lebanon" },
        { id: 96, name: "Lesotho" },
        { id: 97, name: "Liberia" },
        { id: 98, name: "Libya" },
        { id: 99, name: "Liechtenstein" },
        { id: 910, name: "Lithuania" },
        { id: 101, name: "Luxembourg" },
        { id: 102, name: "Madagascar" },
        { id: 103, name: "Malawi" },
        { id: 104, name: "Malaysia" },
        { id: 105, name: "Maldives" },
        { id: 106, name: "Mali" },
        { id: 107, name: "Malta" },
        { id: 108, name: "Marshall Islands" },
        { id: 109, name: "Mauritania" },
        { id: 1010, name: "Mauritius" },
        { id: 111, name: "Mexico" },
        { id: 112, name: "Moldova" },
        { id: 113, name: "Monaco" },
        { id: 114, name: "Mongolia" },
        { id: 115, name: "Montenegro" },
        { id: 116, name: "Morocco" },
        { id: 117, name: "Mozambique" },
        { id: 118, name: "Myanmar" },
        { id: 119, name: "Namibia" },
        { id: 1110, name: "Nauru" },
        { id: 121, name: "Nepal" },
        { id: 122, name: "Netherlands" },
        { id: 123, name: "New Zealand" },
        { id: 124, name: "Nicaragua" },
        { id: 125, name: "Niger" },
        { id: 126, name: "Nigeria" },
        { id: 127, name: "North Macedonia" },
        { id: 128, name: "Norway" },
        { id: 129, name: "Oman" },
        { id: 1210, name: "Pakistan" },
        { id: 131, name: "Palau" },
        { id: 132, name: "Panama" },
        { id: 133, name: "Papua New Guinea" },
        { id: 134, name: "Paraguay" },
        { id: 135, name: "Peru" },
        { id: 136, name: "Philippines" },
        { id: 137, name: "Poland" },
        { id: 138, name: "Portugal" },
        { id: 139, name: "Qatar" },
        { id: 1310, name: "Romania" },
        { id: 141, name: "Russia" },
        { id: 142, name: "Rwanda" },
        { id: 143, name: "Saint Lucia" },
        { id: 144, name: "Samoa" },
        { id: 145, name: "San Marino" },
        { id: 146, name: "Sao Tome & Principe" },
        { id: 147, name: "Saudi Arabia" },
        { id: 148, name: "Senegal" },
        { id: 149, name: "Serbia" },
        { id: 1410, name: "Seychelles" },
        { id: 151, name: "Sierra Leone" },
        { id: 152, name: "Singapore" },
        { id: 153, name: "Slovakia" },
        { id: 154, name: "Slovenia" },
        { id: 155, name: "Solomon Islands" },
        { id: 156, name: "Somalia" },
        { id: 157, name: "South Africa" },
        { id: 158, name: "Spain" },
        { id: 159, name: "Sri Lanka" },
        { id: 1510, name: "Sudan" },
        { id: 161, name: "Suriname" },
        { id: 162, name: "Sweden" },
        { id: 163, name: "Switzerland" },
        { id: 164, name: "Syria" },
        { id: 165, name: "Taiwan" },
        { id: 166, name: "Tajikistan" },
        { id: 167, name: "Tanzania" },
        { id: 168, name: "Thailand" },
        { id: 169, name: "Togo" },
        { id: 1610, name: "Tonga" },
        { id: 171, name: "Trinidad & Tobago" },
        { id: 172, name: "Tunisia" },
        { id: 173, name: "Turkey" },
        { id: 174, name: "Turkmenistan" },
        { id: 175, name: "Tuvalu" },
        { id: 176, name: "Uganda" },
        { id: 177, name: "Ukraine" },
        { id: 178, name: "United Arab Emirates" },
        { id: 179, name: "United Kingdom" },
        { id: 1710, name: "United States" },
        { id: 181, name: "Uruguay" },
        { id: 182, name: "Uzbekistan" },
        { id: 183, name: "Vanuatu" },
        { id: 184, name: "Vatican City" },
        { id: 185, name: "Venezuela" },
        { id: 186, name: "Vietnam" },
        { id: 187, name: "Yemen" },
        { id: 188, name: "Zambia" },
        { id: 189, name: "Zimbabwe" },
    ],
    CommunicationPreferenceList: [
        { id: 1, name: "None" },
        { id: 2, name: "Email" },
        { id: 3, name: "SMS" },
        { id: 4, name: "Phone" },
    ],
    roleOptions: [
        {
            id: 1,
            name: "None",
        },
        {
            id: 2,
            name: "Admin",
        },
        {
            id: 3,
            name: "User",
        },
        {
            id: 4,
            name: "Call Center Associates",
        },
        {
            id: 5,
            name: "Marketing Associates",
        },
    ],
};
